import React from 'react';
import './Welcome.css';

/**
 * Personal greeting shown in an empty chat (2026-10-16): the customer's name and one inspiration
 * line. The chat's own input field (with attachments, voice and send) stays right below it, so
 * the first message starts the conversation through the existing chat flow.
 */
export default function WelcomeHero({ line, phrase, ready = true }) {
  return (
    <section className="welcome-hero" aria-live="polite">
      <span className="welcome-spark" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" focusable="false">
          <path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8L12 3z" />
          <circle cx="19" cy="4.5" r="1.6" />
        </svg>
      </span>
      <h2 className="welcome-line">{line}</h2>
      <p className={`welcome-phrase${ready ? ' is-ready' : ''}`}>{phrase}</p>
    </section>
  );
}
